import {  put } from 'redux-saga/effects';
import axios from '../../Utils/axios'
import { Types } from "../reducers/auth";

export function* handleLogin({ user }) {
  yield put({
    type: Types.SET_USER,
    user
  })
}

export function* logout() {
  yield axios.post('/accounts/signout')
  yield put({
    type: Types.LOG_OUT
  })
}

export const setLogin = (user) => {
  return {
    type: Types.SET_USER,
    user
  }
}